import { textChooser } from "../../../util/textChooser";
import "./new.scss";

export const TagNew = () => {
    return (
        <span className="tag tag-new">
            {textChooser("txt150")}
        </span>
    )
}